var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResumeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 36.6663C29.2049 36.6663 36.6668 29.2044 36.6668 19.9997C36.6668 10.7949 29.2049 3.33301 20.0002 3.33301C10.7954 3.33301 3.3335 10.7949 3.3335 19.9997C3.3335 29.2044 10.7954 36.6663 20.0002 36.6663Z",
    fill: "#EAF2F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9432 13.2334C15.1158 13.1351 15.3113 13.0842 15.5098 13.086C15.7083 13.0877 15.9029 13.1419 16.0736 13.2432C16.0736 13.2431 16.0737 13.2432 16.0736 13.2432L25.8428 19.0323C26.0107 19.1319 26.15 19.2737 26.2466 19.4433C26.3432 19.613 26.394 19.8048 26.394 20C26.394 20.1952 26.3432 20.3871 26.2466 20.5567C26.15 20.7263 26.011 20.8679 25.8431 20.9675L16.0738 26.7568C16.0737 26.7568 16.0738 26.7568 16.0738 26.7568C15.903 26.858 15.7083 26.9123 15.5098 26.9141C15.3113 26.9158 15.1158 26.8649 14.9432 26.7667C14.7707 26.6684 14.6272 26.5262 14.5274 26.3545C14.4276 26.1829 14.375 25.9879 14.375 25.7893V14.2109C14.375 14.0123 14.4276 13.8172 14.5274 13.6455C14.6272 13.4738 14.7707 13.3316 14.9432 13.2334ZM15.625 14.4303V25.5697L25.0238 20L15.625 14.4303Z",
    fill: "#25635E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeCircle);
export default __webpack_public_path__ + "static/media/resume-circle.d4eae9e015e80a8bbe4d0ccb3346fc83.svg";
export { ForwardRef as ReactComponent };